import { thanos26GetJson } from "./thanos26Client";

async function getAllTimeSafeProjPhases(projectid: string): Promise<any> {
    return thanos26GetJson("TimeSafe/TimesafeProjectPhases", { projectid });
}

export default { getAllTimeSafeProjPhases };
